import VueGoogleMaps from '@fawmi/vue-google-maps'
import { defineNuxtPlugin } from '#app'
import type { TwPublicRuntimeConfig } from '~/definitions/AllDefinitions'

export default defineNuxtPlugin((nuxtApp) => {
  const config: TwPublicRuntimeConfig = useRuntimeConfig().public
  nuxtApp.vueApp.use(VueGoogleMaps, {
    load: {
      key: config.GOOGLE_MAPS_API_KEY,
      language: 'en-US',
      libraries: 'drawing,places,geometry',
      loading: 'async',
      v: 'weekly',
    },
    autobindAllEvents: true,
  })
})
